import WorkloadDataTable from "./WorkloadDataTable";
import WorkloadDataByCSR from "./WorkloadDataByCSR";
import React from "react";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../core/et3-ui/ET3Margin";

const WorkloadDataTables = withLiteObserverAndTheme(() => {
  return (
    <React.Fragment>
      <WorkloadDataTable />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <WorkloadDataByCSR />
    </React.Fragment>
  );
});
export default WorkloadDataTables;
